import { QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { useMutation, useQueryClient } from 'react-query';

export const useUpdateUserEmailMutation = () => {
    const client = useUserData();
    const queryClient = useQueryClient();

    const { mutate, mutateAsync } = useMutation(
        QUERY_KEYS.user,
        (email: string) => client.updateUserEmail(email),
        {
            onSuccess: () => queryClient.invalidateQueries(QUERY_KEYS.user),
        }
    );

    return {
        mutate,
        mutateAsync,
    };
};
